import { css } from '@reown/appkit-ui';
export default css `
  .icon-box {
    width: 64px;
    height: 64px;
    border-radius: ${({ borderRadius }) => borderRadius[5]};
    background-color: ${({ colors }) => colors.semanticError010};
  }
`;
//# sourceMappingURL=styles.js.map